import _implicitStylesheets from "./switcher.css";
import _implicitScopedStylesheets from "./switcher.scoped.css?scoped=true";
import _wdsButton from "wds/button";
import {freezeTemplate, registerTemplate} from "lwc";
const stc0 = {
  "search-switcher": true
};
const stc1 = {
  key: 1
};
const stc2 = {
  "data-testid": "appButton"
};
const stc3 = {
  "data-testid": "consultantsButton"
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, c: api_custom_element, h: api_element} = $api;
  const {_m0, _m1, _m2} = $ctx;
  return [api_element("div", {
    classMap: stc0,
    attrs: {
      "role": "group",
      "aria-label": $cmp.labels.tabs.resultsType
    },
    key: 0,
    on: {
      "analytics": _m0 || ($ctx._m0 = api_bind($cmp.handleAnalytics))
    }
  }, [api_element("ul", stc1, [api_custom_element("wds-button", _wdsButton, {
    attrs: stc2,
    props: {
      "ariaPressed": $cmp.tabsVariants.appsSelected,
      "variant": $cmp.tabsVariants.apps,
      "size": "small",
      "name": "apps & solutions",
      "label": $cmp.appSolutionsTabLabel
    },
    key: 2,
    on: {
      "click": _m1 || ($ctx._m1 = api_bind($cmp.switchToApps))
    }
  }), api_custom_element("wds-button", _wdsButton, {
    attrs: stc3,
    props: {
      "ariaPressed": $cmp.tabsVariants.consultantsSelected,
      "variant": $cmp.tabsVariants.consultants,
      "size": "small",
      "name": "consultants",
      "label": $cmp.consultantsTabLabel
    },
    key: 3,
    on: {
      "click": _m2 || ($ctx._m2 = api_bind($cmp.switchToConsultants))
    }
  })])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-7caab9c18cf";
tmpl.legacyStylesheetToken = "undefined-_switcher";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
